export class EscolaModel {
  codigoEscola?: number = 0;
  nome?: string = '';
  nomeCurto?: string = '';
  codigoInep?: number = 0;
  dataInicioAnoLetivo: string = '';
  dataTerminoAnoLetivo: string = '';
  cabecalhoReports: string = '';
  rodapeReports: string = '';
  cabecalho2Reports: string = '';
  rodape2Reports: string = '';
  parametros: string = '';
  tipoRegistro?: string;
  codigoMec?: string;
  codigoSre?: string;
  sre?: string;
  dataCriacao?: Date;
  decretoCriacao?: string;
  prefeitura?: string;
  visualizaEnsinosEspecificos?: boolean;
  situacaoFuncionamento?: number;
  dependenciaAdministrativa?: number;
  endereco?: string;
  numero?: string;
  complemento?: string;
  codigoBairro?: number;
  codigoMunicipio?: number;
  codigoDistrito?: number;
  uf?: string;
  cep?: string;
  zona?: number;
  tipologia?: string;
  ddd?: string;
  telefone?: string;
  telefonePublico1?: string;
  telefonePublico2?: string;
  telefonePublico3?: string;
  fax?: string;
  email?: string;
  cnpj?: string;
  inscricao?: string;
  autorizacaoFuncionamento?: string;
  tipoEscola?: number;
  tipoEscrituracao?: number;
  anoLetivo?: number;
  semestreLetivo?: number;
  latitude?: number | null;
  longitude?: number | null;
  codigoOrgaoRegionalEnsino?: number;
  categoriaEscolaPrivada?: number;
  conveniadaPoderPublico?: number;
  mantenedoraEscolaPrivada?: number;
  mantenedoraEmpresa?: number;
  mantenedoraSindicatos?: number;
  mantenedoraSemFinsLucrativos?: number;
  mantenedoraSistemaS?: number;
  mantenedoraONG?: number;
  cnpjMantenedoraPrincipal?: string;
  regulamentacao?: number;
  inep?: number;
  tipoRegistro10?: string;
  cpfDiretor?: string;
  nomeDiretor?: string;
  cargoResponsavel?: string;
  emailDiretor?: string;
  localFuncPredioEscolar?: number;
  localFuncTemploIgreja?: number;
  localFuncSalasDeEmpresa?: number;
  localFuncCasaProfessor?: number;
  localFuncSalaOutraEscola?: number;
  localFuncGalpaoRancho?: number;
  localFuncPrisional?: number;
  localFuncOutros?: number;
  formaOcupacaoPredio?: number;
  predioCompartilhado?: boolean;
  codEscolaInepCompartilhada1?: string;
  codEscolaInepCompartilhada2?: string;
  codEscolaInepCompartilhada3?: string;
  codEscolaInepCompartilhada4?: string;
  codEscolaInepCompartilhada5?: string;
  codEscolaInepCompartilhada6?: string;
  tipoAguaConsumida?: number;
  aguaRedePublica?: number;
  aguaPocoArtesiano?: number;
  aguaCisterna?: number;
  aguaFonte?: number;
  aguaInexistente?: number;
  energiaEletricaRedePublica?: number;
  energiaEletricaGerador?: number;
  energiaEletricaOutros?: number;
  energiaEletricaInexistente?: number;
  esgotoRedePublica?: number;
  esgotoFossa?: number;
  esgotoInexistente?: number;
  destinoLixoColetaPeriodica?: number;
  destinoLixoQueima?: number;
  destinoLixoJogaEmOutraArea?: number;
  destinoLixoRecicla?: number;
  destinoLixoEnterra?: number;
  destinoLixoOutros?: number;
  dependenciaSalaDiretoria?: number;
  dependenciaSalaProfessores?: number;
  dependenciaSalaSecretaria?: number;
  dependenciaLaboratorioInformatica?: number;
  dependenciaLaboratorioCiencias?: number;
  dependenciaSalaRecursosMultifuncionaisAEE?: number;
  dependenciaQuadraEsporteCoberta?: number;
  dependenciaQuadraEsporteDescoberta?: number;
  dependenciaCozinha?: number;
  dependenciaBiblioteca?: number;
  dependenciaSalaLeitura?: number;
  dependenciaParqueInfantil?: number;
  dependenciaBercario?: number;
  dependenciaBanheiroForaPredio?: number;
  dependenciaBanheiroDentroPredio?: number;
  dependenciaBanheiroEducacaoInfantil?: number;
  dependenciaBanheiroAlunosDeficientes?: number;
  dependenciaViasParaDeficientes?: number;
  dependenciaBanheiroComChuveiro?: number;
  dependenciaRefeitorio?: number;
  dependenciaDespensa?: number;
  dependenciaAlmoxarifado?: number;
  dependenciaAuditorio?: number;
  dependenciaPatioDescoberto?: number;
  dependenciaAlojamentoAluno?: number;
  dependenciaAlojamentoProfessor?: number;
  dependenciaAreaVerde?: number;
  dependenciaLavanderia?: number;
  dependenciaLaboratorioRobotica?: number;
  dependenciaNenhuma?: number;
  numSalasExistentes?: number;
  numSalasUtilizadasDentroEFora?: number;
  equipamentoTV?: number;
  equipamentoVideocassete?: number;
  equipamentoDVD?: number;
  equipamentoParabolica?: number;
  equipamentoCopiadora?: number;
  equipamentoRetroprojetor?: number;
  equipamentoImpressora?: number;
  equipamentoSom?: number;
  equipamentoDatashow?: number;
  equipamentoFax?: number;
  equipamentoFilmadora?: number;
  equipamentoComputadores?: number;
  qteComputadores?: number;
  qteComputadoresUsoAdmin?: number;
  qteComputadoresUsoAlunos?: number;
  acessoInternet?: number;
  bandaLarga?: number;
  totalFuncionarios?: number;
  alimentacaoEscolarParaAlunos?: number;
  ofereceAEE?: number;
  ofereceAtividadeComplementar?: number;
  modalidadeEnsinoRegular?: number;
  modalidadeSubstitutiva?: number;
  modalidadeEJA?: number;
  etapaEnsRegCreche?: number;
  etapaEnsRegPreescola?: number;
  etapaEnsRegEnsFund8Anos?: number;
  etapaEnsRegEnsFund9Anos?: number;
  etapaEnsRegEnsMedMedio?: number;
  etapaEnsRegEnsMedIntegrado?: number;
  etapaEnsRegEnsMedMagisterio?: number;
  etapaEnsRegEnsMedEducProfissional?: number;
  etapaEducEspCreche?: number;
  etapaEducEspPreescola?: number;
  etapaEducEspEnsFund8Anos?: number;
  etapaEducEspEnsFund9Anos?: number;
  etapaEducEspEnsMedMedio?: number;
  etapaEducEspEnsMedIntegrado?: number;
  etapaEducEspEnsMedMagisterio?: number;
  etapaEducEspEnsMedEducProfissional?: number;
  etapaEducEspEJAFundamental?: number;
  etapaEducEspEJAMedio?: number;
  etapaEJAEnsFund?: number;
  etapaEJAProjovem?: number;
  etapaEJAEnsMedio?: number;
  ensFundOrganizadoCiclos?: number;
  localizacaoDiferenciada?: number;
  matDidSocioCultNaoUtiliza?: number;
  matDidSocioCultQuilombola?: number;
  matDidSocioCultIndigena?: number;
  educacaoIndigena?: number;
  linguaMinistrIndigena?: number;
  linguaMinistrPortuguesa?: number;
  codigoLinguaIndigena?: number;
  escolaCedeEspaco?: number;
  escolaAbreFimDeSemana?: number;
  multiseriada?: number;
  conservatorioMusica?: number;
  ciclos?: number;
  conteudoPrincipal?: number;
  escolaReferencia?: number;
  escrituracaoEstadual?: number;
  escolaEspecial?: number;
  baseDadosIntegrada?: number;
  tipoIdentificacaoDiretor?: number;
  identificacaoDiretor?: string;
  formacaoDiretor?: number;
  dataPosseDiretor?: Date;
  nomeSecretario?: string;
  tipoIdentRespAreaPessoal?: number;
  identificacaoSecretario?: string;
  nomeRespAreaPessoal?: string;
  tipoIdentSecretario?: number;
  identificacaoRespAreaPessoal?: string;
  nomeTesoureiro?: string;
  identificacaoTesoureiro?: string;
  orgaoRegionalEnsino?: string;
  escolaPropPegFormacaoAlternacia?: number;
  localFuncSocioeducativo?: number;
  unidadeVinculada?: number;
  codigoEscolaSede?: number;
  codigoIES?: string;
  equipamentoImpressoraMultifuncional?: number;
  modalidadeProfissional?: number;
  aplicaFiltroNoPlanoCurricular?: boolean;
  vinculadaSecretariaEducacao?: number;
  vinculadaSecretariaSeguranca?: number;
  vinculadaSecretariaSaude?: number;
  vinculadaOutroOrgaoPublico?: number;
  mantenedoraOSCIP?: number;
  dependenciaDormitorioAluno?: number;
  dependenciaDormitorioProfessor?: number;
  dependenciaPiscina?: number;
  dependenciaSalaArtes?: number;
  dependenciaSalaMusica?: number;
  dependenciaSalaDanca?: number;
  dependenciaSalaMultiUso?: number;
  dependenciaSalaRepouso?: number;
  dependenciaTerreirao?: number;
  dependenciaViveiro?: number;
  tratamentoLixoSeparacao?: number;
  tratamentoLixoReaproveitamento?: number;
  tratamentoLixoReciclagem?: number;
  tratamentoLixoNaoFaz?: number;
  numSalasUtilizadasFora?: number;
  numSalasClimatizadas?: number;
  numSalasAcessibilidade?: number;
  recursoCorrimao?: number;
  recursoElevador?: number;
  recursoPisosTateis?: number;
  recursoPortas80cm?: number;
  recursoRampas?: number;
  recursoSinalizacaoSonora?: number;
  recursoSinalizacaoTatil?: number;
  recursoSinalizacaoVisual?: number;
  recursoNenhum?: number;
  equipamentoNotebooks?: number;
  equipamentoTablets?: number;
  equipamentoLousaDigital?: number;
  equipamentoScanner?: number;
  codigoLinguaIndigena2?: number;
  codigoLinguaIndigena3?: number;
  internetUsoAlunos?: number;
  internetUsoAdministrativo?: number;
  internetUsoProcessoEnsino?: number;
  internetUsoComunidade?: number;
  internetComputadorMesa?: number;
  internetDispositivosPessoais?: number;
  equipamentosUsoAlunosAcessoInternet?: number;
  internetACabo?: number;
  internetWireless?: number;
  internetBandaLarga?: number;
  rhAuxSecretaria: number = 0;
  rhAuxServicosGerais: number = 0;
  rhBibliotecario: number = 0;
  rhBombeiro: number = 0;
  rhCoordenadorTurno: number = 0;
  rhFonoaudiologo: number = 0;
  rhNutricionista: number = 0;
  rhPsicologo: number = 0;
  rhCozinha: number = 0;
  rhSupPedagogica: number = 0;
  rhSecretario: number = 0;
  rhSeguranca: number = 0;
  rhTecnicos: number = 0;
  materiaisAcervoMultimidia: number = 0;
  materiaisBrinquedosEducacaoInfantil: number = 0;
  materiaisConjuntoCientifico: number = 0;
  materiaisAplificacaoAudio: number = 0;
  materiaisInstrumentosMusicais: number = 0;
  materiaisJogosEducativos: number = 0;
  materiaisAtividadesArtisticas: number = 0;
  materiaisAtividadesDesportivas: number = 0;
  materiaisEducacaoIndigena: number = 0;
  materiaisEtnicoRaciais: number = 0;
  materiaisEducacaoCampo: number = 0;
  materiaisEducacaoProfissional?: boolean;
  materiaisBilingue?: number;
  materiaisInstrumentosProducaoAgricola?: number;
  materiaisEducacaoQuilombola?: number;
  materiaisEducacaoEspecial?: number;
  materiaisAudiovisuaisProducaoEstudantil?: number;
  materiaisKitRobotica?: number;
  materiaisEducacaoEmocional?: number;
  materiaisNenhum?: boolean;
  fazExameSelecao: number = 0;
  cotasPPI: number = 0;
  cotasPCD: number = 0;
  cotasRenda: number = 0;
  cotasEscolaPublica: number = 0;
  cotasOutras: number = 0;
  cotasAmplaConcorrencia: number = 0;
  possuiBlog: number = 0;
  compartilhaEspacoComunidade: number = 0;
  usaEquipamentosNoEntorno: number = 0;
  projetoPoliticoAtualizou: number = 0;
  projetoPoliticoNaoAtualizou: number = 0;
  projetoPoliticoNaoPossui: number = 0;
  codigoRegiao?: number;
  orgModulos?: number;
  orgNaoSeriados?: number;
  orgFundamentalCiclos?: number;
  orgSemestrais?: number;
  orgSerieAnos?: number;
  projetoPolitico?: number;
  reservaSemReserva?: number;
  reservaOutros?: number;
  reservaPCD?: number;
  reservaPublica?: number;
  reservaRenda?: number;
  reservaPPI?: number;
  orgaoPais?: number;
  orgaoPaisMestres?: number;
  orgaoConselho?: number;
  orgaoGremio?: number;
  orgaoOutros?: number;
  orgaoSemOrgao?: number;
  rhViceDiretor?: number;
  rhOrientador?: number;
  rhAssistenteSocial?: number;
  codigoResponsavelRecursosHumanos?: number;
  // ================================
  termoDeFomentoN130192014?: boolean;
  acordoDeCooperacao1N130192014?: boolean;
  contratoDePrestacaoServico1?: boolean;
  contratoDeConsorcioPublico1?: boolean;
  termoDeColaboracao1N130192014?: boolean;
  termoDeCooperacaoTecnicaFinanceira1?: boolean;
  // ================================
  termoDeFomento2N130192014?: boolean;
  acordoDeCooperacao2N130192014?: boolean;
  contratoDePrestacaoServico2?: boolean;
  contratoDeConsorcioPublico2?: boolean;
  termoDeColaboracao2N130192014?: boolean;
  termoDeCooperacaoTecnicaFinanceira2?: boolean;
  // ================================
  secretariaEstadual?: boolean;
  secretariaMunicipal?: boolean;
  naoPossuiParceria?: boolean;
  federal?: boolean;
  estadual?: boolean;
  municipal?: boolean;
  cnpjEscolaPrivada?: string;
  esgotoFossaRudimentar?: number;
  dependenciaEstudioGravacao?: number;
  dependenciaEstudioDanca?: boolean;
  rhInterprete?: number;
  dependenciaBanheiroExclusivoFuncionarios?: number;
  dependenciaSalaoOficinaEducacaoProfissional?: number;
  dependenciaLaboratorioEducacaoProfissional?: number;
  internetNaoPossui?: number;
  internetRedesInterligadasNaoPossui?: boolean;
  equipamentoNenhum?: boolean;
  bairro?: string;
  codigoPessoalDiretor?: number;
  criterioAcessoCargo?: number;
  regimeContratacao?: number;
  acesso?: string;
  areaConstruida?: number;
  areaEsporte?: number;
  areaTotal?: number;
  divisas?: string;
  observacaoFisica?: string;
  idPessoaViceDiretor?: number;
  // Somente exibição: o nome do vice-diretor NÃO é persistido (só o idPessoaViceDiretor).
  // Resolvido no carregamento do formulário via Funcionario/{id}.
  nomeViceDiretor?: string;
  desenvolveAcaoAreaEducacaoAmbiental?: number;
  desenvolveQualAcaoAreaEducacaoAmbientalExperiencia: boolean = false;
  desenvolveQualAcaoAreaEducacaoAmbientalEventos: boolean = false;
  desenvolveQualAcaoAreaEducacaoAmbientalComponenteCurricular: boolean = false;
  desenvolveQualAcaoAreaEducacaoAmbientalProjetos: boolean = false;
  desenvolveQualAcaoAreaEducacaoAmbientalEixo: boolean = false;
  desenvolveQualAcaoAreaEducacaoAmbientalNenhuma: boolean = false;
  codigoPessoalRespArea?: number;
  codigoPessoaTesoureiro?: number;
  codigoPessoaSecretaria?: number;
  rhRevisorBraille?: number;
  rhAgronomoHorticultores?: number;
  recursoSinalizacaoAlarme?: number;
  dependenciaAreaDeHorta?: number;
  aguaCarroPipa?: number;
  fundoTransporte?: Uint8Array;
  fundoPasse?: Uint8Array;
  nomeMantenedoraPrincipal?: string;
  numSalasCantinhoLeitura: number = 0;
  dependenciaPatrioCoberto?: number;
}

export class ParametrosModel {
  utilizaJustificativaFaltasTelaProfessor: boolean = false;
  utilizaObservacaoEstudantesTelaProfessor: boolean = false;
}

export enum TipoParametrosEscola {
  utilizaJustificativaFaltasTelaProfessor = 'utilizaJustificativaFaltasTelaProfessor',
  utilizaObservacaoEstudantesTelaProfessor = 'utilizaObservacaoEstudantesTelaProfessor',
}

/** Endereço da escola a localizar no mapa (POST /Escola/LocalizarEndereco). */
export interface EnderecoEscolaParaLocalizar {
  cep?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  bairro?: string | null;
  municipio?: string | null;
  uf?: string | null;
}

/**
 * Resposta de POST /Escola/LocalizarEndereco. A API omite false/0 do JSON: `encontrado` e
 * `aproximado` chegam `undefined` quando falsos — teste por verdadeiro, nunca `=== false`.
 */
export interface LocalizacaoEnderecoEscolaModel {
  encontrado?: boolean;
  motivo?: string | null;
  latitude?: number;
  longitude?: number;
  aproximado?: boolean;
  descricao?: string;
}
